/* eslint-disable */
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, ControlLabel, Form, FormGroup, FormControl, HelpBlock, InputGroup, Modal } from 'react-bootstrap';
import { NotificationManager } from 'react-notifications';
import { ss, logout, adminBecome, setToken, newOrder, errorsFrom } from '../utils/util';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import ChangePasswordForm from './partials/ChangePasswordForm';
import './Account.css'
import {
  fetchUser,
  changePassword,
} from '../actions';


class Account extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  constructor(props) {
    super(props);
    this.state = { showChangePassword: false };
  }

  changePassword(e, values) {
    e.preventDefault();
    this.props.changePassword(values)
      .then(resp => {
        if (!resp.error) {
          this.setState({ showChangePassword: false })
          NotificationManager.success('Changed your password!', '', 3000);
        }
      });
  }

  renderChangePassword() {
    return (
      <Modal show={this.state.showChangePassword} onHide={() => this.setState({ showChangePassword: false })}>
        <Modal.Header closeButton>
          <Modal.Title>Change your password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ChangePasswordForm
            values={{}}
            errors={this.props.passwordErrors}
            buttonText="Change Password"
            cancelText="Cancel"
            onSubmit={(e, values) => this.changePassword(e, values)}
            onCancel={() => this.setState({ showChangePassword: false })}
          />
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    return (
      <Wrapper className="Account" title="Account">
        <div><b>Your username:</b> {this.props.user.username}</div>
        <div><b>Your email:</b> {this.props.user.email}</div>
        <h2>Change your password</h2>
        <p>You can set a new password for your account.</p>
        {this.renderChangePassword()}
        <p>
          <Button bsStyle="default" onClick={() => this.setState({ showChangePassword: true })}>Change Password</Button>
        </p>

        <hr/>

        <Button bsStyle="primary" onClick={() => logout()}>Sign Out</Button>

      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user || {},
    profile: (state.user && state.user.profile) || {},
    passwordErrors: errorsFrom(state, 'changePassword'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setUpSubscription: (...args) => dispatch(setUpSubscription(...args)),
    changePassword: (...args) => dispatch(changePassword(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Account);



/** WEBPACK FOOTER **
 ** ./src/components/Account.js
 **/